import type { JSX } from 'react'

export interface MedicationNameProps {
  display: string
  doseSummary?: string
}

export function MedicationName({
  display,
  doseSummary,
}: MedicationNameProps): JSX.Element {
  return <>{doseSummary ? `${display}, ${doseSummary}` : display}</>
}
